<div class="contentHeight">
    <h1>
        <button (click)="isAnimating = true">
            <span class="colored" [class.animate]="isAnimating" (animationend)="isAnimating = false;">404</span>
        </button>
    </h1>
    <p>
        {{ 'cloud.menu.missing.message' | translate }}
    </p>
</div>
